
export const features = {
  'features.digitalProfiles': 'Digital Farm Profiles',
  'features.digitalProfilesDesc': 'Create comprehensive digital profiles for each farm, tracking all relevant information in one place.',
  'features.subsidyMatching': 'Subsidy Matching',
  'features.subsidyMatchingDesc': 'Automatically match farms with available subsidies and grants based on their profiles and activities.',
  'features.applicationTracking': 'Application Tracking',
  'features.applicationTrackingDesc': 'Manage the entire subsidy application process from drafting to submission and approval.',
} as const;
